import clsx from 'clsx';
import * as React from 'react';

import { diff } from '@gitbook/doc-core';

import { shortcuts, useKeyboardShortcuts } from '../../../Keyboard';
import { type RightGutterComponentType, useDocumentNodeComments } from '../..';
import { CommentButton } from './CommentButton';

/**
 * Button displayed in the right gutter of the editor, for adding or reading comments on a block.
 */
export const BlockCommentButton = React.memo(function BlockCommentButton(
    props: React.ComponentProps<RightGutterComponentType>
) {
    const { nodeKey: rawNodeKey, visible, style, shortcutsActive } = props;
    const nodeKey = diff.getOriginalDiffKey(rawNodeKey);

    const { hasComments, openNodeComments, nodeState } = useDocumentNodeComments({
        nodeKey,
    });

    // Bind the shortcut to open this palette.
    useKeyboardShortcuts(
        shortcutsActive
            ? {
                  [shortcuts.EDITOR_COMMENT]: () => openNodeComments(),
              }
            : {},
        ['editor-selection-collapsed', 'editor-selection-expanded']
    );

    return (
        <div
            className={clsx(
                hasComments && 'page-has-comments',
                'flex min-w-fit items-start justify-start gap-1 transition max-md:hidden',
                visible || hasComments || nodeState.addNewPopoverIsOpen
                    ? 'opacity-100'
                    : 'opacity-0 hover:opacity-100 group-hover/gutter:opacity-100 has-[button[aria-expanded="true"]]:opacity-100'
            )}
            style={style}
            data-hide-on-drag
        >
            <CommentButton nodeKey={nodeKey} iconOnly shortenLabel label="Comment on block" />
        </div>
    );
});
